















































































import Vue from "vue";
import Editor, { IEditorEmitArgs } from "@/components/molecules/Editor.vue";
import ManuscriptBackup from "@/components/organisms/ManuscriptBackup.vue";
import ManuscriptPreview from "@/components/organisms/ManuscriptPreview.vue";
import TextVerticalIcon from "@/components/atoms/TextVerticalIcon.vue";
import LinkIcon from "@/components/atoms/LinkIcon.vue";
import DropupMenu, { Item } from "@/components/molecules/DropupMenu.vue";
import HamburgerMenu from "@/components/molecules/HamburgerMenu.vue";
import { Manuscript, ManuscriptSetting, Novel, Plan } from "@/lib/models";
import clone from "lodash/cloneDeep";
// NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
// import { downloadPublicImage } from "@/lib/s3";
// import PremiumFeatureDialog, { PremiumFeatureDialogProps } from "@/components/ui/PremiumFeatureDialog.vue";
import ManuscriptSettingsDialog, { ManuscriptSettingsDialogProps } from "@/components/ui/ManuscriptSettingsDialog.vue";
import ExportManuscriptPdfDialog, {
  ExportManuscriptPdfDialogProps,
} from "@/components/ui/ExportManuscriptPdfDialog.vue";
import ColorThemeDialog from "@/components/ui/ColorThemeDialog.vue";
import EditorController from "@/components/molecules/EditorController.vue";
import ProofreadingSettingsDialog from "@/components/ui/ProofreadingSettingsDialog.vue";
import { UserClient } from "@/lib/clients";
import { NolaApiInitializer } from "@/initializer";
// dialog
import { Dialog } from "@/lib/utils";
import DialogVue from "@/components/ui/Dialog.vue";
import { showOkCancelDialog, openManuscriptEditorMenuDialog } from "@/lib/dialog";
import EpisodeListDialog, { EpisodeListDialogProps } from "@/components/ui/nolaNovel/EpisodeListDialog.vue";
import NolaNovelIntroduction from "@/components/ui/nolaNovel/NolaNovelIntroduction.vue";
import CupertinoAlertDialog, { CupertinoAlertDialogProps } from "@/components/ui/dialogs/CupertinoAlertDialog.vue";
import NolaNovelUpdateConfirm, {
  NolaNovelUpdateConfirmProps,
} from "@/components/ui/nolaNovel/NolaNovelUpdateConfirm.vue";
import EpisodeDelinkConfirm, { EpisodeDelinkConfirmProps } from "@/components/ui/nolaNovel/EpisodeDelinkConfirm.vue";
import ProofreadingConfirmationDialog from "@/components/ui/ProofreadingConfirmationDialog.vue";
import AutoIndentConfirmationDialog from "@/components/ui/AutoIndentConfirmationDialog.vue";

const contentMaxLenth = 100000;

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Editor,
    ManuscriptBackup,
    ManuscriptPreview,
    TextVerticalIcon,
    LinkIcon,
    DropupMenu,
    HamburgerMenu,
    EditorController,
    ProofreadingConfirmationDialog,
    AutoIndentConfirmationDialog
  },

  props: {
    novelId: String,
    manuscriptKey: String,
  },

  data() {
    const {
      onSelectCountType,
      showRestoreData,
      showManuscriptSettings,
      showColorTheme,
      showProofreadingSettings,
      showExportManuscriptPdf,
    } = this as any;

    const countTypeList: Item[] = [
      {
        name: "全文字数",
        value: "onlyCharacter",
        callback() {
          onSelectCountType(this.value);
        },
      },
      {
        name: "空白を含む全文字数",
        value: "addBlank",
        callback() {
          onSelectCountType(this.value);
        },
      },
      {
        name: "改行を含む全文字数",
        value: "addNewLine",
        callback() {
          onSelectCountType(this.value);
        },
      },
      {
        name: "空白/改行を含む全文字数",
        value: "all",
        callback() {
          onSelectCountType(this.value);
        },
      },
    ];

    const hamburgerMenuItems: Item[] = [
      {
        name: "原稿の設定",
        icon: "cog",
        callback() {
          showManuscriptSettings();
        },
      },
      {
        name: "自動校正機能の設定",
        icon: "checkbox-marked-outline",
        callback() {
          showProofreadingSettings();
        },
      },
      {
        name: "カラーテーマ選択",
        icon: "palette",
        callback() {
          showColorTheme();
        },
      },
      {
        name: "データバックアップ",
        icon: "cloud-upload-outline",
        callback() {
          showRestoreData();
        },
      },
      {
        name: "原稿のPDF保存",
        icon: "tray-arrow-down",
        callback() {
          showExportManuscriptPdf();
        },
      },
    ];

    return {
      title: "",
      preTitle: "",
      content: "",
      preContent: "",
      saved: false,
      copied: false,
      isShowRestoreData: false,
      backupContent: null,
      countTypeList,
      hamburgerMenuItems,
      hasNolaNovelAccount: false,
    };
  },

  watch: {
    saveTimeout() {
      if (this.saveTimeout) {
        this.save();
        this.$store.dispatch("manuscriptModule/stopSaveTimeout");
      }
    },
  },

  async created() {
    const { initialize } = this;
    initialize();
  },

  methods: {
    // initialize

    async initialize() {
      const { manuscript } = this;
      const { title, content } = manuscript;
      this.title = title || "";
      this.content = content || "";
      this.preTitle = String(this.title);
      this.preContent = String(this.content);

      try {
        const results = await new UserClient().checkConnectedOtherServices();
        const { nolaNovel } = results;
        if (nolaNovel) {
          this.hasNolaNovelAccount = nolaNovel.result ?? false;
        }
      } catch (e) {
        // 特にエラーでも何もしない
      }

      const {
        hamburgerMenuItems,
        episodeIdFromNolaNovel,
        onExportButtonClick,
        showNolaNovelDelinkConfirmDialog,
      } = this;
      const item: Item = {
        name: "Nolaノベルと連携する",
        icon: "export-variant",
        callback: () => {
          onExportButtonClick(episodeIdFromNolaNovel !== undefined);
        },
      };

      if (episodeIdFromNolaNovel) {
        item.name = "Nolaノベルとの連携を解除する";
        item.callback = () => showNolaNovelDelinkConfirmDialog(episodeIdFromNolaNovel);
      }

      this.hamburgerMenuItems = hamburgerMenuItems.filter(
        (item) => item.name !== "Nolaノベルと連携する" && item.name !== "Nolaノベルとの連携を解除する"
      );
      this.hamburgerMenuItems.push(item);
    },

    // execute

    async save() {
      const { novelId, title, content, manuscriptKey, changed } = this;

      // バックアップとしてLocalStorageへの保存を行う
      try {
        const savedDate = new Date().toLocaleString("ja");
        const localStorageManuscript = JSON.stringify({
          savedDate,
          title,
          content,
        });
        localStorage.setItem(manuscriptKey, localStorageManuscript);
      } catch (error: any) {
        console.error("localStorageへの保存に失敗しました");
        console.error(`ERROR : ${JSON.parse(error)}`);
      }

      if (!changed) return;

      if (this.contentLength > contentMaxLenth) {
        this.showErrorDialog(
          "本文の文字数が10万字を越えています。<br />10万字以内に編集して再度保存を実行してください。<br />※別の原稿にて続きをお書きください。"
        );
        return;
      }

      const key = manuscriptKey;
      this.$store.dispatch("manuscriptModule/updateManuscript", {
        novelId,
        key,
        title,
        content,
        callback: async () => {
          this.preTitle = clone(title);
          this.preContent = clone(content);
          this.setModified(false);

          this.saved = true;
          setTimeout(() => (this.saved = false), 2000);

          this.$notify({
            title: "保存しました",
            type: "success",
            duration: 2000,
          });
        },
      });
    },
    hideRestoreData() {
      this.isShowRestoreData = false;
    },
    async copyToClipBoard() {
      if ((navigator as any).clipboard) {
        (navigator as any).clipboard.writeText(this.backupContent.content);
        this.copied = true;
        setTimeout(() => (this.copied = false), 2000);
      }
    },
    async goToMultiEditor() {
      const { novelId, manuscriptKey } = this;
      if (this.isFree) {
        // NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
        // const premiumFeatureDialog = new Dialog(PremiumFeatureDialog);
        // const data: PremiumFeatureDialogProps = {
        //   title: "マルチ執筆モードはプレミアム機能です",
        //   text: "Nolaプレミアムにご登録いただくと【全画面表示】で【資料を見ながら】執筆が可能な『マルチ執筆モード』をご利用いただけます。執筆がリアルタイムに反映される縦書きプレビューも同時にご利用いただけますので、お手すきの際にぜひご利用いただけますと幸いです。",
        //   image: (await downloadPublicImage("shared/images/gif/manuscript_multi_editor.gif")) as string,
        // };
        // premiumFeatureDialog.show(data);

        this.$router.push({ name: "subscriptionAnnounce", query: { from: "multiEditor" } });

        return;
      }

      this.$router.push({
        name: "multiEditor",
        params: {
          novelId,
          manuscriptKey,
        },
      });
    },
    navigateToNolaNovelEditPage(id: string) {
      let url = process.env.VUE_APP_NOLANOVEL_WEB;

      if (!url) {
        throw new Error("NolaノベルのWebサイトURLが環境変数に含まれていません。");
      }

      const { novelId, manuscript } = this;
      url = `${url}/episode/edit/${id}?novelid=${novelId}&episodeid=${manuscript.key}`;
      window.open(url, process.env.VUE_APP_NOLANOVEL_NAME ?? "");
    },

    // event handle

    async handleBackAction() {
      const { novelId, changed } = this;
      if (changed) {
        const yes = await showOkCancelDialog({
          title: "確認",
          content: "保存されていない変更があります。<br />変更を破棄して戻りますか？",
          okButton: "破棄する",
          cancelButton: "キャンセル",
        });
        if (!yes) {
          return;
        }
      }

      this.$router.push({ name: "editor", params: { novelId } });
    },
    onExportButtonClick(isPost) {
      const { hasNolaNovelAccount } = this;
      if (!hasNolaNovelAccount) {
        const introduction = new Dialog(NolaNovelIntroduction);
        introduction.show();
        return;
      }

      const { changed, showUnsavedConfirm } = this;
      if (changed) {
        showUnsavedConfirm();
        return;
      }

      const { episodeIdFromNolaNovel, showNolaNovelExportConfirm } = this;

      if (episodeIdFromNolaNovel) {
        showNolaNovelExportConfirm(episodeIdFromNolaNovel);
        return;
      }

      const { showNolaNovelListDialog } = this;
      showNolaNovelListDialog(isPost);
    },
    async onClickPreview() {
      if (this.isFree) {
        // NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
        // const premiumFeatureDialog = new Dialog(PremiumFeatureDialog);
        // const data: PremiumFeatureDialogProps = {
        //   title: "執筆時の縦書きプレビューはプレミアム機能です",
        //   text: "Nolaプレミアムにご登録いただくと、原稿の執筆時にリアルタイムで反映される『縦書きプレビュー機能』をご利用いただけます。一行辺りの文字数やページ辺りの行数も設定可能ですので、お手すきの際にぜひご活用いただだけたら幸いです。",
        //   image: (await downloadPublicImage("shared/images/gif/manuscript_vertical_writing.gif")) as string,
        // };
        // premiumFeatureDialog.show(data);

        this.$router.push({ name: "subscriptionAnnounce", query: { from: "verticalWriting" } });

        return;
      }
      this.$store.dispatch("manuscriptModule/switchPreviewOnManuscriptEditor");
    },
    async onChangeTitle(args) {
      const { value, isComposing } = args;

      this.title = value;
      this.setModified(this.changed);

      if (this.changed && this.autoSave && !isComposing) {
        this.$store.dispatch("manuscriptModule/startSaveTimeout");
      }
    },
    async onChangeContent(args) {
      const { value, isComposing } = args;

      this.content = value;
      this.setModified(this.changed);

      if (this.changed && this.autoSave && !isComposing) {
        this.$store.dispatch("manuscriptModule/startSaveTimeout");
      }
    },
    onStartComposition() {
      if (this.changed && this.autoSave) {
        this.$store.dispatch("manuscriptModule/stopSaveTimeout");
      }
    },
    onEndComposition() {
      if (this.changed && this.autoSave) {
        this.$store.dispatch("manuscriptModule/startSaveTimeout");
      }
    },
    onSelectCountType(countTypeValue) {
      this.$store.dispatch("manuscriptModule/selectCountType", countTypeValue);
    },
    toggleAutoSave() {
      this.$store.dispatch("manuscriptModule/toggleAutoSave");
    },
    toggleShowEditorController() {
      this.$store.dispatch("manuscriptModule/toggleShowEditorController");
    },
    toggleAutoIndent() {
      this.$store.dispatch("manuscriptModule/toggleAutoIndent");
    },
    // view

    showUnsavedConfirm() {
      const completeDialog = new Dialog(CupertinoAlertDialog);
      const data: CupertinoAlertDialogProps = {
        title: "未保存の内容があります",
        content: "未保存のデータがあります。保存を実行してから投稿することが可能です。",
        action: "閉じる",
      };
      completeDialog.show(data);
    },
    showRestoreData() {
      const { manuscriptKey } = this;
      // LocalStorageのデータ有無確認
      const localStorageManuscript = localStorage.getItem(manuscriptKey);
      const jsonLocalStorageManuscript = localStorageManuscript ? JSON.parse(localStorageManuscript) : null;
      // プロパティの確認
      const currentPropList = jsonLocalStorageManuscript ? Object.keys(jsonLocalStorageManuscript) : null;
      const expectPropList = ["title", "content"];
      let confirmResult = true;
      for (let index = 0; index < expectPropList.length; index += 1) {
        const prop = expectPropList[index];
        if (currentPropList && currentPropList.indexOf(prop) >= 0) {
          confirmResult = true;
        } else {
          confirmResult = false;
          break;
        }
      }

      if (jsonLocalStorageManuscript && confirmResult) {
        this.backupContent = jsonLocalStorageManuscript;
      } else {
        this.backupContent = { title: "", content: "" };
      }

      // 画面切り替え
      this.isShowRestoreData = true;
    },
    showManuscriptSettings() {
      const { novelId, plan } = this;
      const manuscriptSettingsDialog = new Dialog(ManuscriptSettingsDialog);
      const data: ManuscriptSettingsDialogProps = {
        novelId,
        isChangeable: Boolean(plan),
        positive: "保存する",
        positiveCallback: async () => {},
      };
      manuscriptSettingsDialog.show(data);
    },
    showColorTheme() {
      const colorThemeDialog = new Dialog(ColorThemeDialog);
      colorThemeDialog.show();
    },
    showProofreadingSettings() {
      const proofreadingDialog = new Dialog(ProofreadingSettingsDialog);
      proofreadingDialog.show();
    },
    showExportManuscriptPdf() {
      const { novelId } = this;
      const exportManuscriptPdfDialog = new Dialog(ExportManuscriptPdfDialog);
      const data: ExportManuscriptPdfDialogProps = {
        novelId,
      };
      exportManuscriptPdfDialog.show(data);
    },
    async showMenu() {
      const isShowRestoreData = await openManuscriptEditorMenuDialog();
      if (isShowRestoreData) {
        this.showRestoreData();
      }
    },
    showErrorDialog(message: string) {
      const confirmDialog = new Dialog(DialogVue);
      const options = {
        title: "エラー",
        content: message,
      };

      confirmDialog.show(options);
    },
    showPublishSharedLink() {
      this.$store.dispatch("sharedLinkModule/showPublishSharedLink");
    },
    async showNolaNovelExportConfirm(id) {
      const confirmDialog = new Dialog(NolaNovelUpdateConfirm);
      const data: NolaNovelUpdateConfirmProps = {
        id,
        content: `この原稿を、Nolaノベル上に投稿された連携済みエピソードに上書きしてよろしいですか？`,
      };
      const result = await confirmDialog.show(data);
      const { navigateToNolaNovelEditPage } = this;
      if (result) {
        navigateToNolaNovelEditPage(id);
      }
    },
    async showNolaNovelListDialog(isPost: boolean) {
      const { novelId, manuscriptKey, novelIdFromNolaNovel } = this;
      const novelListDialog = new Dialog(EpisodeListDialog);
      const data: EpisodeListDialogProps = {
        novelId,
        manuscriptId: manuscriptKey,
        isPost,
        novelIdFromNolaNovel,
      };

      const result = await novelListDialog.show(data);
      if (result) {
        const completeDialog = new Dialog(CupertinoAlertDialog);
        const data: CupertinoAlertDialogProps = {
          title: "連携が完了しました",
          content: "今後はこの原稿をNolaからNolaノベルに投稿する際は、自動でエピソードが選択されます。",
          action: "閉じる",
        };
        completeDialog.show(data);
      }

      NolaApiInitializer.init();
      const { initialize } = this;
      initialize();
    },
    async showNolaNovelDelinkConfirmDialog(id) {
      const { novelId, manuscriptKey } = this;
      const deleteDialog = new Dialog(EpisodeDelinkConfirm);
      const data: EpisodeDelinkConfirmProps = {
        novelId,
        manuscriptId: manuscriptKey,
        episodeId: id,
      };

      const result = await deleteDialog.show(data);
      if (result) {
        const completeDialog = new Dialog(CupertinoAlertDialog);
        const data: CupertinoAlertDialogProps = {
          title: "連携を解除しました",
          content:
            "再度連携を行う場合は、Nolaノベルアイコンまたはメニュー内の「Nolaノベルと連携する」を選択してください。",
          action: "閉じる",
        };
        completeDialog.show(data);
      }

      NolaApiInitializer.init();
      const { initialize } = this;
      initialize();
    },
  },

  computed: {
    novel() {
      const { novelId } = this;
      const { getters } = this.$store;
      const novel = getters["novelModule/novel"](novelId) as Novel | undefined;
      return novel;
    },
    manuscript() {
      const { getters } = this.$store;
      return getters["manuscriptModule/manuscript"](this.manuscriptKey);
    },
    changed() {
      return this.preTitle !== this.title || this.preContent !== this.content;
    },
    exceeded() {
      return this.contentLength > contentMaxLenth;
    },
    contentLength() {
      let rubyLength = 0;
      const content = clone(this.content) as string;

      // eslint-disable-next-line no-control-regex
      const rubyRegExp = new RegExp("[|｜][^|｜\r\n]*?《.*?》", "gu");
      const textWithRuby = content.match(rubyRegExp);
      if (textWithRuby) {
        textWithRuby.forEach((text) => {
          const onlyRubyRegExp = new RegExp("《.*?》$");
          const textOnlyRuby = text.match(onlyRubyRegExp);
          rubyLength += textOnlyRuby![0].length + 1; // 親文字の縦棒をカウントから除くための+1
        });
      }

      let contentLength = 0;
      switch (this.countType) {
        case "addBlank":
          contentLength = content.replace(/\n/g, "").length;
          break;
        case "addNewLine":
          contentLength = content.replace(/[^\S\n]/g, "").length;
          break;
        case "all":
          contentLength = content.length;
          break;
        case "onlyCharacter":
        default:
          contentLength = content.replace(/\s+|\n/g, "").length;
          break;
      }

      return contentLength - rubyLength;
    },
    pageCount() {
      const content = clone(this.content) as string;

      /** ルビを除外する */
      const splittedContent = content.split("\n");
      const removedRubyContent = splittedContent.map((content) => {
        let result = content;
        // eslint-disable-next-line no-control-regex
        const rubyRegExp = new RegExp("[|｜][^|｜\r\n]*?《.*?》", "gu");
        const textWithRuby = content.match(rubyRegExp);
        if (textWithRuby) {
          textWithRuby.forEach((text: string) => {
            let replaceText = text;
            const parentRegExp = new RegExp("[|｜]");
            replaceText = replaceText.replace(parentRegExp, "");
            replaceText = replaceText.replace("《.*?》", "");
            result = content.replace(text, replaceText);
          });
        }
        return result;
      });

      /** 原稿の設定情報を取得 */
      const { wordCountOnVertical, lineCountPerPage } = this.manuscriptSetting as ManuscriptSetting;

      /** 行数を計算する */
      let lineCount = 0;
      removedRubyContent.forEach(
        (content) => (lineCount += content ? Math.ceil(content.length / wordCountOnVertical) : 1)
      );
      return Math.ceil(lineCount / lineCountPerPage);
    },
    isShowPreview() {
      const { $store, isFree } = this;
      const { getters } = $store;

      const isShowPreview = getters["manuscriptModule/isShowPreviewOnManuscriptEditor"];

      return !isFree && isShowPreview;
    },
    manuscriptList() {
      const key = this.manuscriptKey;
      const { title, content } = this;
      const manuscriptObject: Manuscript = {
        key,
        title,
        content,
      };
      return [manuscriptObject];
    },
    theme() {
      return this.$store.getters["manuscriptModule/theme"];
    },
    isShowPublishSharedLink() {
      return this.$store.getters["sharedLinkModule/isShowPublishSharedLink"];
    },
    countType() {
      return this.$store.getters["manuscriptModule/countType"];
    },
    countTypeName() {
      const countTypeValue = this.countType;
      const countType = (this.countTypeList as Item[]).find((countType) => countType.value === countTypeValue);
      const countTypeName = countType ? countType.name : "";

      /** 原稿の設定情報を取得 */
      const { wordCountOnVertical, lineCountPerPage } = this.manuscriptSetting as ManuscriptSetting;

      return `${countTypeName}（縦${wordCountOnVertical}×横${lineCountPerPage}）`;
    },
    wordCountInfo() {
      const { contentLength } = this;
      const { pageCount } = this;

      return `${contentLength}文字（${pageCount}P換算）`;
    },
    plan() {
      return this.$store.getters["userModule/plan"] as Plan;
    },
    isFree() {
      return this.plan === Plan.free;
    },
    manuscriptSetting() {
      return this.$store.getters["novelModule/manuscriptSetting"](this.novelId) as ManuscriptSetting;
    },
    saveTimeout() {
      return this.$store.getters["manuscriptModule/saveTimeout"];
    },
    saveStatus() {
      const { autoSave, saved } = this;

      if (autoSave) {
        return saved ? "自動保存しました" : "自動保存設定中";
      }
      return saved ? "保存しました" : "";
    },
    lastModified() {
      return `最終保存：${this.manuscript.lastModified || "-"}`;
    },
    autoSave() {
      return this.$store.getters["manuscriptModule/autoSave"];
    },
    isShowEditorController() {
      return this.$store.getters["manuscriptModule/isShowEditorController"];
    },
    autoIndent() {
      return this.$store.getters["manuscriptModule/autoIndent"];
    },
    hamburgerMenuTogglableItems() {
      const { autoSave, toggleAutoSave, autoIndent, toggleAutoIndent, isShowEditorController, toggleShowEditorController } = this;

      const hamburgerMenuTogglableItems: Item[] = [
        {
          name: "自動保存",
          icon: "content-save-edit-outline",
          value: autoSave,
          callback() {
            toggleAutoSave();
          },
        },
        {
          name: "自動字下げ",
          icon: "cog",
          value: autoIndent,
          callback() {
            toggleAutoIndent();
          },
        },
        {
          name: "コントロールバーの表示",
          icon: "toolbox-outline",
          value: isShowEditorController,
          callback() {
            toggleShowEditorController();
          },
        },
      ];

      return hamburgerMenuTogglableItems;
    },

    // NolaNovel

    novelIdFromNolaNovel() {
      const { novel } = this;

      if (!novel) {
        return undefined;
      }

      const { associatedData } = novel as Novel;

      if (!associatedData) {
        return undefined;
      }

      const { nolaNovel } = associatedData;

      if (!nolaNovel) {
        return undefined;
      }

      const { id } = nolaNovel;

      if (!id) {
        return undefined;
      }

      return id;
    },
    episodeIdFromNolaNovel() {
      const { manuscript } = this;
      if (!manuscript) {
        return undefined;
      }

      const { associatedData } = manuscript as Manuscript;

      if (!associatedData) {
        return undefined;
      }

      const { nolaNovel } = associatedData;

      if (!nolaNovel) {
        return undefined;
      }

      const { id } = nolaNovel;

      if (!id) {
        return undefined;
      }

      return id;
    },
  },
});

interface Props {
  novelId: string;
  manuscriptKey: string;
}

interface Data {
  title: string;
  preTitle: string;
  content: string;
  preContent: string;
  saved: boolean;
  copied: boolean;
  isShowRestoreData: boolean;
  backupContent: any;
  countTypeList: Item[];
  hamburgerMenuItems: Item[];
  hasNolaNovelAccount: boolean;
}

interface Methods {
  initialize(): void;

  save(): Promise<void>;
  hideRestoreData(): void;
  copyToClipBoard(): void;
  handleBackAction(): Promise<void>;
  goToMultiEditor(): Promise<void>;
  navigateToNolaNovelEditPage(id: string): void;

  onClickPreview(): void;
  onSelectCountType(countTypeValue: any): void;
  onChangeTitle(args: IEditorEmitArgs): Promise<void>;
  onChangeContent(args: IEditorEmitArgs): Promise<void>;
  onStartComposition(): void;
  onEndComposition(): void;
  onExportButtonClick(isPost: boolean): void;
  toggleAutoSave(): void;
  toggleShowEditorController(): void;
  toggleAutoIndent(): void;

  showUnsavedConfirm(): void;
  showRestoreData(): void;
  showMenu(): Promise<void>;
  showPublishSharedLink(): void;
  showErrorDialog(message: string): void;
  showManuscriptSettings(): void;
  showProofreadingSettings(): void;
  showColorTheme(): void;
  showExportManuscriptPdf(): void;
  showNolaNovelExportConfirm(id: string): void;
  showNolaNovelListDialog(isPost: boolean): void;
  showNolaNovelDelinkConfirmDialog(id: string): void;
}

interface Computed {
  novel?: Novel;
  manuscript: Manuscript;
  changed: boolean;
  exceeded: boolean;
  contentLength: number;
  pageCount: number;
  isShowPreview: boolean;
  manuscriptList: Manuscript[];
  theme: string;
  isShowPublishSharedLink: boolean;
  countType: string;
  countTypeName: string;
  wordCountInfo: string;
  plan: Plan;
  isFree: boolean;
  manuscriptSetting: ManuscriptSetting;
  saveTimeout: boolean;
  saveStatus: string;
  lastModified: string;
  autoSave: boolean;
  isShowEditorController: boolean;
  autoIndent: boolean;
  hamburgerMenuTogglableItems: Item[];

  // NolaNovel
  novelIdFromNolaNovel?: string;
  episodeIdFromNolaNovel?: string;
}
